module.exports = __webpack_public_path__ + "img/logo-mirt300.0696edce.png";